import { merge } from "lodash-es";
import { create } from "zustand";
import { immer } from "zustand/middleware/immer";

import { Organization } from "@/types/organization";
import { User } from "@/types/user";
import { Workspace } from "@/types/workspace";

interface GlobalState {
  users: Array<User>;
  loggedInUser: User | null;
  updateLoggedInUser: (user: User | null) => void;
  addUsers: (users: User[]) => void;
  updateUser: (id: string, updates: Partial<User>) => void;
  activeWorkspaceId: string | null;
  setActiveWorkspaceId: (id: string) => void;
  activeWorkspace: Workspace | null;
  setActiveWorkspace: (workspace: Workspace | null) => void;
  organization: Organization | null;
  setOrganization: (organization: Organization | null) => void;
  reset: () => void;
}

export const useGlobalStore = create<GlobalState>()(
  immer((set, get) => ({
    activeWorkspaceId: null,
    setActiveWorkspaceId(id) {
      set((state) => ({
        ...state,
        activeWorkspaceId: id,
      }));
    },
    activeWorkspace: null,
    setActiveWorkspace(workspace) {
      set((state) => ({
        ...state,
        activeWorkspace: workspace,
      }));
    },
    addUsers(users) {
      set((state) => ({
        ...state,
        users,
      }));
    },
    updateUser(id, updates) {
      const users = get().users;

      const foundUser = users.find((user) => user.id === id);

      merge(foundUser, updates);
    },
    users: [],
    loggedInUser: null,
    updateLoggedInUser(user) {
      set((state) => ({
        ...state,
        loggedInUser: user,
      }));
    },
    organization: null,
    setOrganization(organization) {
      set((state) => ({
        ...state,
        organization,
      }));
    },
    reset() {
      set({
        users: [],
        loggedInUser: null,
        activeWorkspaceId: null,
        activeWorkspace: null,
        organization: null,
      });
    },
  })),
);
